import styled from "@emotion/styled";

import { fontRobotoCondensed, setFullViewportWidthStyles, theme } from "shared/lib/styles";

import SvgMynewsLogo from "./my-news-logo.svg";

export const PageContainer = styled.div`
  ${setFullViewportWidthStyles()}
`;

export const PageWrapper = styled.div`
  inline-size: 100%;
  max-inline-size: 2056px;
  margin-block: 0;
  margin-inline: auto;
`;

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding-block-start: 24px;

  color: #001246;
  font-weight: 700;
  font-size: 24px;
  font-family: ${fontRobotoCondensed};
  line-height: 23px;
  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    margin-block: 0 16px;
    margin-inline: 0;
    padding-block-start: 64px;

    font-size: 48px;
    line-height: 56px;
  }
`;

export const MynewsLogo = styled(SvgMynewsLogo)`
  inline-size: 80.5px;
  margin-block-start: 5px;
  margin-inline-start: 5px;
  ${theme.breakpoints.up("tablet")} {
    inline-size: 167px;
    margin-block-start: 9px;
    margin-inline-start: 10px;
  }
`;
